import { createAction } from '@reduxjs/toolkit';

const saveLuggageFormValues = createAction(
  'ui/sealink/ferryFlow/saveLuggageFormValues'
);

const clearLuggageByTypeIds = createAction(
  'ui/sealink/ferryFlow/clearLuggageByTypeIds'
);

const setSameDayLuggageRemoved = createAction(
  'ui/sealink/ferryFlow/setSameDayLuggageRemoved'
);

export {
  saveLuggageFormValues,
  clearLuggageByTypeIds,
  setSameDayLuggageRemoved,
};
